import Vue from "vue";
import Router from "vue-router";
import routes from '@/core/routes/paths/index'

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes
});
